// import React, { useRef, useState } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import { IconButton, Card, CardContent, Typography } from '@material-ui/core';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import ChevronRightIcon from '@material-ui/icons/ChevronRight';

// const useStyles = makeStyles((theme) => ({
//   root: {
//     height: '15vh',
//     // backgroundColor: '#fff',
//     // boxShadow: theme.shadows[3],
//     position: 'relative',
//     overflow: 'hidden',
//   },
//   scrollContainer: {
//     height: '100%',
//     overflowX: 'auto',
//     overflowY: 'hidden',
//     scrollbarWidth: 'none',
//     '&::-webkit-scrollbar': {
//       display: 'none',
//     },
//   },
//   cardsWrapper: {
//     display: 'flex',
//     gap: '16px',

//     padding: '0.8%',
//   },
//   card: {
//     flexShrink: 0,
//     width: '180px',
//     height: '100%',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//     color: '#fff',
//     cursor: 'pointer',
//     transition: 'transform 0.2s',
//     '&:hover': {
//       transform: 'scale(1.05)',
//     },
//   },
//   cardBlue: {
//     backgroundColor: '#2196f3',
//   },
//   cardPurple: {
//     backgroundColor: '#9c27b0',
//   },
//   cardPink: {
//     backgroundColor: '#e91e63',
//   },
//   cardGreen: {
//     backgroundColor: '#4caf50',
//   },
//   cardOrange: {
//     backgroundColor: '#ff9800',
//   },
//   cardRed: {
//     backgroundColor: '#f44336',
//   },
//   cardIndigo: {
//     backgroundColor: '#3f51b5',
//   },
//   cardTeal: {
//     backgroundColor: '#D5EBF6',

//   },
//   title: {

//     fontSize: '1.1rem',
//     fontWeight: 600,
//     color: '#68BBD6',
//     opacity:'100%'
//   },
//   subject: {
//     textAlign:"left",
//     fontSize: '0.7rem',
//     fontWeight: 'normal',    
//     color: '#000000',
//   },
//   value: {
//     textAlign:"left",
//      fontSize: '0.7rem',
//    fontWeight: 'normal',    

//     color: '#587f9b',
//   },
//   arrowButton: {
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     zIndex: 10,
//     backgroundColor: '#fff',
//     boxShadow: theme.shadows[4],
//     '&:hover': {
//       backgroundColor: '#f5f5f5',
//     },
//   },
//   leftArrow: {
//     left: '8px',
//   },
//   rightArrow: {
//     right: '8px',
//   },
//   content: {
//     padding: '24px',
//   },
// }));

// export default function HorizontalCards(props) {
//   const classes = useStyles();
//   const scrollRef = useRef(null);
//   const [showLeftArrow, setShowLeftArrow] = useState(false);
//   const [showRightArrow, setShowRightArrow] = useState(true);
//   const { ordersList } = props;
//   const cards=ordersList;

//   const scroll = (direction) => {
//     const container = scrollRef.current;
//     if (!container) return;

//     const scrollAmount = 300;
//     const newScrollLeft = direction === 'left' 
//       ? container.scrollLeft - scrollAmount 
//       : container.scrollLeft + scrollAmount;

//     container.scrollTo({
//       left: newScrollLeft,
//       behavior: 'smooth'
//     });
//   };

//   const handleScroll = () => {
//     const container = scrollRef.current;
//     if (!container) return;

//     setShowLeftArrow(container.scrollLeft > 0);
//     setShowRightArrow(
//       container.scrollLeft < container.scrollWidth - container.clientWidth - 10
//     );
//   };

//   return (
//     <div>
//       {/* Horizontal Cards Section */}
//       <div className={classes.root}>
//         {/* Left Arrow */}
//         {showLeftArrow && (
//           <IconButton
//             onClick={() => scroll('left')}
//             className={`${classes.arrowButton} ${classes.leftArrow}`}
//             aria-label="scroll left"
//           >
//             <ChevronLeftIcon />
//           </IconButton>
//         )}

//         {/* Cards Container */}
//         <div 
//           ref={scrollRef}
//           onScroll={handleScroll}
//           className={classes.scrollContainer}
//         >
//           <div className={classes.cardsWrapper}>
//             {cards.map((card) => (
//               <Card
//                 key={card.jobId}
//                 className={`${classes.card} ${classes.cardTeal}`}
//                 elevation={3}
//                 // onClick={onHandleChange}
//               >
//                 <CardContent>
//                   <Typography className={classes.title}>
//                     CK - {card.orderId}
//                   </Typography>
//                   <Typography className={classes.subject}>
//                     <b>Status : </b>
//                         <span className={classes.value}> 
//                            {card.statusLabel}
//                         </span>
//                   </Typography>
//                   <Typography className={classes.subject}>
//                     <b>changed on : </b>
//                         <span className={classes.value}> 
//                            {card.createdOn}
//                         </span>
//                   </Typography>
//                 </CardContent>
//               </Card>
//             ))}
//           </div>
//         </div>

//         {/* Right Arrow */}
//         {showRightArrow && (
//           <IconButton
//             onClick={() => scroll('right')}
//             className={`${classes.arrowButton} ${classes.rightArrow}`}
//             aria-label="scroll right"
//           >
//             <ChevronRightIcon />
//           </IconButton>
//         )}
//       </div>


//     </div>
//   );
// }
import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Card, CardContent, Typography } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "10px",
    height: '18vh',
    position: 'relative',
    overflow: 'hidden',
  },
  scrollContainer: {
    height: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  cardsWrapper: {
    display: 'flex',
    gap: '16px',
    padding: '0.2%',
    marginLeft: "5px"
    // paddingLeft: '0.1%',
  },
  card: {
    flexShrink: 0,
    width: '180px',
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    position: 'relative',
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[8],
    },
  },
  cardTeal: {
    backgroundColor: '#D5EBF6',
  },
  // Selected card style
  cardSelected: {
    backgroundColor: '#68BBD6',
    border: '3px solid #2196f3',
    transform: 'scale(1.08)',
    boxShadow: theme.shadows[10],
  },
  title: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: '#68BBD6',
    opacity: '100%',
  },
  titleSelected: {
    color: '#fff',
  },
  subject: {
    textAlign: 'left',
    fontSize: '0.7rem',
    fontWeight: 'normal',
    color: '#777777',
  },
  subjectSelected: {
    color: '#fff',
  },
  value: {
    textAlign: 'left',
    fontSize: '0.7rem',
    fontWeight: 'normal',
    color: '#587f9b',
  },
  valueSelected: {
    color: '#fff',
    fontWeight: 600,
  },
  arrowButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    backgroundColor: '#fff',
    boxShadow: theme.shadows[4],
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  leftArrow: {
    left: '8px',
  },
  rightArrow: {
    right: '8px',
  },
  content: {
    padding: '24px',
  },
  // Check icon for selected card
  checkIcon: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    color: '#4caf50',
    fontSize: '1.5rem',
  },
}));

export default function HorizontalCards(props) {
  const classes = useStyles();
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const { ordersList, onOrderSelect, handleChange } = props;
  const cards = ordersList;

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollAmount = 300;
    const newScrollLeft = direction === 'left'
      ? container.scrollLeft - scrollAmount
      : container.scrollLeft + scrollAmount;

    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  };

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;

    setShowLeftArrow(container.scrollLeft > 0);
    setShowRightArrow(
      container.scrollLeft < container.scrollWidth - container.clientWidth - 10
    );
  };

  // Handle card selection
  const handleCardClick = (card) => {
    ////debugger;
    setSelectedOrderId(card.orderId);
    handleChange(card.orderId);
    // Call parent callback if provided
    if (onOrderSelect) {
      onOrderSelect(card);

    }
  };

  // Check if card is selected
  const isSelected = (orderId) => selectedOrderId === orderId;

  return (
    <div>
      {/* Horizontal Cards Section */}
      <div className={classes.root}>
        {/* Left Arrow */}
        {showLeftArrow && (
          <IconButton
            onClick={() => scroll('left')}
            className={`${classes.arrowButton} ${classes.leftArrow}`}
            aria-label="scroll left"
          >
            <ChevronLeftIcon />
          </IconButton>
        )}

        {/* Cards Container */}
        <div
          ref={scrollRef}
          onScroll={handleScroll}
          className={classes.scrollContainer}
        >
          <div className={classes.cardsWrapper}>
            {cards.map((card) => {
              const selected = isSelected(card.orderId);

              return (
                <Card
                  key={card.jobId}
                  className={`${classes.card} ${selected ? classes.cardSelected : classes.cardTeal
                    }`}
                  elevation={selected ? 5 : 3}
                  onClick={() => handleCardClick(card)}
                >
                  {/* Show check icon for selected card */}
                  {selected && (
                    <CheckCircleIcon className={classes.checkIcon} />
                  )}

                  <CardContent>
                    <Typography
                      className={`${classes.title} ${selected ? classes.titleSelected : ''
                        }`}
                    >
                      CK - {card.orderId}
                    </Typography>
                    <Typography
                      className={`${classes.subject} ${selected ? classes.subjectSelected : ''
                        }`}
                    >
                      <b>Status : </b>
                      <span
                        className={`${classes.value} ${selected ? classes.valueSelected : ''
                          }`}
                      >
                        {card.orderStatusLabel}
                      </span>
                    </Typography>
                    <Typography
                      className={`${classes.subject} ${selected ? classes.subjectSelected : ''
                        }`}
                    >
                      <b>Changed on : </b>
                      <span
                        className={`${classes.value} ${selected ? classes.valueSelected : ''
                          }`}
                      >
                        {card.statusChangedOn}
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Right Arrow */}
        {showRightArrow && (
          <IconButton
            onClick={() => scroll('right')}
            className={`${classes.arrowButton} ${classes.rightArrow}`}
            aria-label="scroll right"
          >
            <ChevronRightIcon />
          </IconButton>
        )}
      </div>
    </div>
  );
}